import * as loglevel from 'loglevel';
import config from './config/config.json';

loglevel.setLevel(config.logLevel as loglevel.LogLevelDesc);

export default loglevel;
